import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { GetUserDetailsURL, staffPosUrl } from "../../assets/api/BaseURL";
import { useToast } from "../../../context/ToastContext";
import SlidingText from "./SlidingText";
// import LiveChat from "./LiveChat";

const NavBar = ({ handleToggle, toggleCanvas }) => {
  const location = useLocation();
  const { setPlan, setCurrency } = useToast();

  const { addToast } = useToast();
  const [token, setToken] = useState("");
  const [planDetails, setPlanDetails] = useState(null);
  const [logoutModel, setLogoutModel] = useState(false);


  const [user, setUser] = useState({
    contact_name: "",
    login_email: "",
    notification_email: "",
    username: "",
    notification_mobile: "",
    login_mobile_number: "",
  });

  const capitalizeFirstLetter = (str) => {
    if (str) {
      const words = str.split(" ");

      const capitalizedWords = words.map((word) => {
        if (word.length === 0) {
          return "";
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      });

      const capitalizedString = capitalizedWords.join(" ");

      return capitalizedString;
    }
  };

  const handleLogout = async (tableClear) => {
    // e.preventDefault();
    clearTableData('pk')
    clearTableData('dl')
    localStorage.removeItem("token");
    localStorage.removeItem("planDetails");
    localStorage.removeItem("userId");
    localStorage.removeItem("currencySymbol");
    if (tableClear) {


      localStorage.clear()
    }


    window.location.href = "/auth";
  };

  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, [token]);

  useEffect(() => {
    if (localStorage.getItem("planDetails")) {
      setPlanDetails(JSON.parse(localStorage.getItem("planDetails")));
    }
  }, []);

  useEffect(() => {
    if (token) {
      async function getUser() {
        try {
          const response = await axios.get(GetUserDetailsURL, {
            headers: { authorization: `Bearer ${token}` },
          });

          if (response.status === 200 && response.data.data) {
            setUser(response.data.data);

            // response.data.data
            localStorage.setItem("restaurantName", response.data.data.contact_name)
            localStorage.setItem("no_of_bill_printing", response.data.data.no_of_bill_printing)
            localStorage.setItem("round_off_amount", response.data.data.round_off_amount)
            localStorage.setItem("kot_items_delete", response.data.data.kot_items_delete)



            localStorage.setItem("whatesapp_message", response.data.data.whatesapp_message)

            if (response.data.data.upi_address) {
              localStorage.setItem("upi_address", response.data.data.upi_address)
            }
            if (response.data.data.whatsapp_api_access_token) {
              localStorage.setItem("whatsapp_api_access_token", response.data.data.whatsapp_api_access_token)
            }
            if (response.data.data.whatsapp_vendor_uid) {
              localStorage.setItem("whatsapp_vendor_uid", response.data.data.whatsapp_vendor_uid)
            }
            if (response.data.data.whatsapp_massageing_api_base_URL) {
              localStorage.setItem("whatsapp_massageing_api_base_url", response.data.data.whatsapp_massageing_api_base_URL)
              localStorage.setItem("whatsapp_massageing_api_url", response.data.data.whatsapp_massageing_api_base_URL + '/' + response.data.data.whatsapp_vendor_uid)
            }
            if (response.data.data.currency_symbol != null) {
              localStorage.setItem("currencySymbol", response.data.data.currency_symbol);
            }
            if (response.data.data.currency_code != null && response.data.data.currency_code !== "") {
              localStorage.setItem("currencyCode", response.data.data.currency_code);
            }
            if (setCurrency) {
              setCurrency(response.data.data.currency_symbol ?? "", response.data.data.currency_code ?? "");
            }


            if (response.data.data.planDetailsResult) {

              localStorage.setItem("planDetails", JSON.stringify(response.data.data.planDetailsResult));


              setPlan(response.data.data.planDetailsResult);
            }




          }
        } catch (error) {
          if (error.response && error.response.data.message) {
            addToast("error", error.response.data.message);
          } else {
            addToast("error", error.message);
          }
          console.log(error);
        }
      }
      getUser();
    }
  }, [token]);


  const clearTableData = (table) => {
    const storedOrderList = JSON.parse(localStorage.getItem("orderList")) || {};

    if (storedOrderList[table]) {
      delete storedOrderList[table];
    }

    localStorage.setItem("orderList", JSON.stringify(storedOrderList));


  };

  const showDaysRemaining =
    Boolean(user.remaining_days) && user.auth_global === 1;
  const showPlanBlock = Boolean(planDetails && planDetails.plan_name);

  return (
    <>
      <SlidingText
        mode="globalPortal"
        navOffsetPx={97}
        contentKey={`${location.pathname}-${location.key}`}
      />
      <div
        className={logoutModel ? "modal fade show d-block" : "modal fade"}
        id="exampleModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content w-85">
            <div className="modal-header py-2">
              <h5 className="modal-title" id="exampleModalLabel">
                Sign Out
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => { setLogoutModel(false) }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body py-2">
              <div className="clear_and_logout_text_padding">
                <h4>
                  {/* Clicking on the “Clear and Logout” buttons will clear the tables. */}
                  Are you sure you want to sign out?
                </h4>
              </div>
            </div>

            <div className="modal-footer" style={{ padding: "15px 0px" }}>
              <button
                type="button"
                className="btn btn-primary  "
                data-dismiss="modal"
                onClick={() => { handleLogout(false) }}
              >
                Sign Out
              </button>
              <button
                type="button"
                className="btn btn-danger  me-3"
                data-dismiss="modal"
                onClick={() => { setLogoutModel(false) }}
              >
                Cancel
              </button>
            </div>


            {/* <div className="modal-footer" style={{ padding: "15px 0px" }}>
              <div className="row" style={{ width: "100%" }}>
                <div className="col-3 valign">
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-dismiss="modal"
                    onClick={() => { handleLogout(false) }}
                  >
                    Logout
                  </button>{' '}

                </div>
                <div className="col-8 valign">
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-dismiss="modal"
                    onClick={() => { handleLogout(true) }}
                  >
                    Clear and Logout
                  </button>

                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className="navbar-menu-wrapper d-flex align-items-top">

        {/* {toggleCanvas ?

          <Link to="/fooders_cp">
            <img
              className="responsive-link"
              style={{
                width: "30px",
                marginTop: "10px",
                transform: "translateX(-30px)", // Adjust this value for desired left movement
              }}
              src="images/mini-kr-logo.svg"
              alt="logo"
            />
          </Link>
          : <></>} */}

        <ul className="navbar-nav hwdth">
          <li className="nav-item font-weight-semibold d-none d-lg-block ms-0 navbar-nav-item-welcome">
            <div className="d-flex flex-column w-100" style={{ minWidth: 0 }}>
              <h1 className="welcome-text mb-0 d-flex align-items-baseline w-100" style={{ minWidth: 0 }}>
                <span className="flex-shrink-0 me-1">Hello,</span>
                <span
                  className="fw-bold flex-grow-1"
                  style={{
                    minWidth: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    color: "#1f2a37",
                  }}
                  title={user.contact_name ? capitalizeFirstLetter(user.contact_name) : ""}
                >
                  {capitalizeFirstLetter(user.contact_name)}
                </span>
              </h1>
              {user.staffRoleName && (
                <h6 className="text-muted mt-1">
                  {user.staffRoleName}
                </h6>
              )}
            </div>
          </li>
        </ul>



        <ul className="navbar-nav ms-auto">

          {(showDaysRemaining || showPlanBlock) && (
            <li
              className={`nav-item d-none d-lg-block me-2${
                showPlanBlock ? " dropdown" : ""
              }`}
            >
              <div className="header-plan-days-row d-flex align-items-center">
                {showDaysRemaining && (
                  <div
                    className="header-days-pill-ref"
                    aria-label={`${user.remaining_days} days remaining on your plan`}
                  >
                    <span className="header-days-pill-ref__accent">
                      {user.remaining_days} Days
                    </span>
                    <span className="header-days-pill-ref__muted">Remaining</span>
                  </div>
                )}
                {showDaysRemaining && showPlanBlock && (
                  <span className="header-plan-days-sep" aria-hidden="true">
                    |
                  </span>
                )}
                {showPlanBlock && (
                  <div className="plan-group-shell">
                    {user.staffCount > 0 ? (
                      <a
                        href={staffPosUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pos-tag"
                        onClick={(e) => e.stopPropagation()}
                      >
                        POS
                      </a>
                    ) : (
                      <Link
                        to="/view_staff"
                        className="pos-tag"
                        onClick={(e) => e.stopPropagation()}
                      >
                        POS
                      </Link>
                    )}
                    <button
                      type="button"
                      className="plan-group-btn"
                      id="PlanUserDropdown"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="true"
                      aria-expanded="false"
                      aria-haspopup="true"
                    >
                      <span className="plan-name">
                        Current Plan - {planDetails.plan_name}
                        <i className="mdi mdi-chevron-down" aria-hidden="true" />
                      </span>
                    </button>
                    <div
                      className="dropdown-menu dropdown-menu-end navbar-dropdown"
                      aria-labelledby="PlanUserDropdown"
                    >
                      <div className="dropdown-header text-center">
                        <p className="mb-1 mt-3 font-weight-semibold">
                          {capitalizeFirstLetter(user.contact_name)}
                        </p>
                        {user && user.fooder_uniqueid && (
                          <p className="fw-light text-muted mb-0">
                            {user.fooder_uniqueid}
                          </p>
                        )}
                        <p className="fw-light text-muted mb-0">{user.login_email}</p>
                      </div>
                      <Link to="/account_management" className="dropdown-item">
                        <i className="dropdown-item-icon mdi mdi-account-outline text-primary me-2"></i>
                        Account
                      </Link>
                      <Link to="/upgrade?plan=gold" className="dropdown-item">
                        <i className="dropdown-item-icon mdi mdi-star-outline text-primary me-2"></i>
                        Upgrade Plan
                      </Link>
                      <button
                        type="button"
                        className="dropdown-item"
                        onClick={() => {
                          setLogoutModel(true);
                        }}
                      >
                        <i className="dropdown-item-icon mdi mdi-power text-primary me-2"></i>
                        Sign Out
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </li>
          )}

        </ul>
        <button
          className="navbar-toggler navbar-toggler-right d-lg-none align-self-center text-white"
          type="button"
          onClick={handleToggle}
        >
          <span className="mdi mdi-menu"></span>
        </button>

      </div>

      {/* <LiveChat /> */}
    </>
  );
};

export default NavBar;
